<template>
    <button class="btn btn-xs  text-warning  p-0 d-flex" @click="create()">

        <i :class="{'fa-regular fa-heart' : item?.favorite == null ,'fa-solid fa-heart' : item?.favorite != null ,  }"></i>

    </button>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    props: {
        item: {
            required: true,
            type: Object,
        },
    },
    methods: {
        create() {

            const that = this;
            const id = toast.info('جاري إضافة المحتوى ...' ,{ icon: 'fa-solid fa-cloud-arrow-up'  });

            axios.post('user/favorites',
                {
                    'product_id' : this.item.id,
                    'type' : this.item?.favorite == null ? 'add' : 'remove'
                }
            ).then(response => {
                toast.dismiss(id);

                this.$emit('update:item',response.data);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });
        }
    }
}
</script>
